<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('spending.contractor')} *`" v-model="form.contractor">
            <option v-for="contractor in contractors" :value="contractor.id">
              {{ contractor.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('spending.amount')} *`" type="currency" v-model="form.amount"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :label="`${$t('spending.date')} *`" v-model="form.date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('spending.number')} *`" type="string" v-model="form.act_number"></form-input>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field class="file">
          <b-upload v-model="form.file">
            <a class="button is-warning">
              <span>{{ $t('spending.file') }} *</span>
            </a>
          </b-upload>
          <span class="file-name">
            <template v-if="form.file">{{ form.file.name }}</template>
            <template v-if="form.file_name && !form.file">{{ form.file_name }}</template>
            <template v-if="!form.file_name && !form.file">{{ $t('interface.noFileSelected') }}</template>
          </span>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'

  const defaultSpendingData = {
    contractor: null,
    date: new Date(),
    amount: null,
    file: null,
    file_name: null,
    act_number: null
  }

  export default {
    props: ['spendingData', 'editMode'],
    data() {
      return {
        form: this.spendingData || {...defaultSpendingData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        this.errors = []
        if (this.form.contractor === null || this.form.amount === null || this.form.act_number === null) {
          this.errors.push(this.$t('interface.requiredFields'))
        } else if (this.form.amount <= 0) {
          this.errors.push('Укажите сумму освоения')
        } else if (!this.isEdit && this.form.file === null) {
          this.errors.push('Выберите файл')
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            date: prepareDate(this.form.date)
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.$store.dispatch('Spending/getRelations', this.$route.params.projectId)
    },
    computed: {
      ...mapState('Spending', ['contractors'])
    },
    watch: {
      spendingData(data) {
        this.form = data
      }
    }
  }
</script>